import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@components/ui/dropdown-menu.tsx";
import { SecondaryButton } from "@sprout/buttons";
import ArrowDownIcon from "@sprout/icons/arrow_down.tsx";

type Props = {
  label: string;
  options: { label: string; value: string }[];
  onSelect: (v: string) => void;
};

const ApplicationSortDropdown = ({ label, options, onSelect }: Props) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <SecondaryButton size="medium">
          <div className="flex items-center justify-center gap-1 w-full">
            {label}
            <ArrowDownIcon size="sm" color="green" />
          </div>
        </SecondaryButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="applications-sort-menu">
        {options.map((o) => (
          <DropdownMenuItem key={o.value} onSelect={() => onSelect(o.value)}>
            {o.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ApplicationSortDropdown;
